import { useGetMerchantQuery } from "Api/Queries/Merchants/useGetMerchantQuery";
import { MerchantNotesForm } from "Components/Hunter/Merchants/CompleteRegistration/Tabs/MerchantNotes/MerchantNotesForm";
import { MerchantNotesSkeleton } from "Components/Hunter/Merchants/CompleteRegistration/Tabs/MerchantNotes/MerchantNotesSkeleton";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { useResource } from "Translations/Resources";
import { Resources } from "Translations/Resources";

const RESOURCES =
  Resources.Hunter.Merchants.CompleteRegistration.MerchantCompany;

type Props = {
  formId: string;
  merchantPublicID: string;
  onAfterSubmit: () => void;
};

export const MerchantNotes = ({
  formId,
  merchantPublicID,
  onAfterSubmit,
}: Props) => {
  const { t } = useResource();
  const { data: merchantData, isLoading } =
    useGetMerchantQuery(merchantPublicID);

  if (isLoading) {
    return <MerchantNotesSkeleton />;
  }

  if (!merchantData) {
    return <ErrorText>{t(RESOURCES.LoadingError)}</ErrorText>;
  }

  return (
    <MerchantNotesForm
      formId={formId}
      merchantPublicID={merchantPublicID}
      onAfterSubmit={onAfterSubmit}
      defaultValues={{ note: merchantData.note ?? "" }}
    />
  );
};
